import script from "./ArticleSearchView.vue?vue&type=script&lang=js"
export * from "./ArticleSearchView.vue?vue&type=script&lang=js"

import "./ArticleSearchView.vue?vue&type=style&index=0&id=205642ce&lang=scss"

const __exports__ = script;

export default __exports__